var _a, _b, _c, _d, _e, _f;
import { urlParse } from '../url';
import BrowserParser from './parser';
export const ua = window.navigator.userAgent;
const browser = new BrowserParser(ua);
const userAgent = ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) || '';
const isIpadMini = userAgent.includes('ipad') && userAgent.includes('mini');
export const isMobile = (_d = (_c = window._GATEWAY_UA) === null || _c === void 0 ? void 0 : _c.loadMobile) !== null && _d !== void 0 ? _d : (!isIpadMini && userAgent.indexOf('mobile') > -1);
export const isPC = (_f = (_e = window._GATEWAY_UA) === null || _e === void 0 ? void 0 : _e.loadPC) !== null && _f !== void 0 ? _f : !isMobile;
export const getBrowserName = browser.getBrowserName.bind(browser);
export const getBrowserVersion = browser.getBrowserVersion.bind(browser);
/**
 * 获取客户端/浏览器信息
 */
export const getClientInfo = () => {
    var _a, _b, _c;
    const { __next_lowcode_mobile__ } = urlParse(window.location.href, true, true).query;
    const userAgent = ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
    const isIpadMini = userAgent.toLocaleLowerCase().includes('ipad') &&
        userAgent.toLocaleLowerCase().includes('mini');
    const isMobile = __next_lowcode_mobile__ === 'true' ||
        ((_c = (_b = window._GATEWAY_UA) === null || _b === void 0 ? void 0 : _b.loadMobile) !== null && _c !== void 0 ? _c : (!isIpadMini && userAgent.toLocaleLowerCase().indexOf('mobile') > -1));
    return {
        isMobile,
        isPC: !isMobile,
        userAgent,
    };
};
